import { action } from 'satcheljs';
export var refreshSharingTipsForAttachment = action('REFRESH_SHARING_TIPS_FOR_ATTACHMENT', function (attachmentId) { return ({
    attachmentId: attachmentId,
}); });
//# sourceMappingURL=publicActions.js.map